import { render, staticRenderFns } from "./ScannedItemsList.vue?vue&type=template&id=c6dfe094&scoped=true&"
import script from "./ScannedItemsList.vue?vue&type=script&lang=js&"
export * from "./ScannedItemsList.vue?vue&type=script&lang=js&"
import style0 from "./ScannedItemsList.vue?vue&type=style&index=0&id=c6dfe094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dfe094",
  null
  
)

export default component.exports